var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4205 11.7014C10.2659 13.2919 11.6668 14.5753 13.3988 15.346C13.5256 15.4013 13.6658 15.4252 13.8056 15.4155C13.9454 15.4058 14.0801 15.3627 14.1964 15.2905L16.7467 13.7254C16.8595 13.6562 16.9893 13.6139 17.1243 13.6025C17.2593 13.5911 17.3953 13.6109 17.5199 13.66L22.2911 15.5419C22.4532 15.6052 22.5885 15.7154 22.6767 15.8556C22.7649 15.9959 22.8011 16.1588 22.7799 16.3197C22.6291 17.4057 22.0534 18.4039 21.1604 19.1273C20.2675 19.8508 19.1187 20.2499 17.929 20.25C14.2546 20.25 10.7308 18.9067 8.13258 16.5156C5.53441 14.1245 4.07477 10.8815 4.07477 7.49997C4.07483 6.40513 4.50852 5.34786 5.29464 4.5261C6.08075 3.70435 7.16538 3.17448 8.34544 3.03569C8.52027 3.01622 8.69723 3.04956 8.84967 3.1307C9.00211 3.21183 9.12177 3.33636 9.19062 3.48552L11.2372 7.88032C11.2902 7.994 11.3117 8.11796 11.3 8.24116C11.2883 8.36436 11.2437 8.48299 11.1701 8.58647L9.47533 10.9696C9.39819 11.0768 9.35259 11.2006 9.34298 11.3288C9.33337 11.4571 9.36008 11.5855 9.4205 11.7014V11.7014Z",
    stroke: "#B27D52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.574c7b632b6dd2d9c2934f9f82a1aabe.svg";
export { ForwardRef as ReactComponent };